import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-profile',
  templateUrl: './footer-profile.component.html',
  styleUrls: ['./footer-profile.component.scss']
})
export class FooterProfileComponent implements OnInit {
  btnTextShow: string = 'Read More';
  btnTextHide: string = 'Read Less';
  btnText: string = this.btnTextShow;
  constructor() { }

  ngOnInit() {
  }
  readContent(): void {
    if (this.btnText === this.btnTextShow) {
      this.btnText = this.btnTextHide;
    }
    else {
      this.btnText = this.btnTextShow;
    }
  }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/footer-profile/footer-profile.component.ts